import React from 'react';
import {Helmet} from 'react-helmet';
import webUtils from '../../../utils/webUtils';

const ImageObjectSchema = ({imageUrls = []}) => {
  if (!Array.isArray(imageUrls) || imageUrls.length === 0) return null;

  const structuredData = imageUrls.map(url => ({
    '@context': 'https://schema.org/',
    '@type': 'ImageObject',
    contentUrl: webUtils.normalizeImageUrl(url),
    creditText: 'PerfectCorp.',
  }));

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
    </Helmet>
  );
};

export default ImageObjectSchema;
